<script setup lang="ts"></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
    <path
      d="M1 12C1.00004 5.9249 5.92489 1 12 1C18.0751 1.00004 23 5.92493 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM5.38965 8.99121C4.83272 9.6042 4.87837 10.5532 5.49121 11.1104L10.3184 15.498C11.2719 16.3649 12.7281 16.3649 13.6816 15.498L18.5088 11.1104C19.1216 10.5532 19.1673 9.6042 18.6104 8.99121C18.0532 8.37838 17.1042 8.33275 16.4912 8.88965L12 12.9736L7.50879 8.88965C6.8958 8.33275 5.9468 8.37838 5.38965 8.99121Z"
      fill="currentColor"
    />
  </svg>
</template>
